'use strict';

var DayOfWeek = /* @__PURE__ */ ((DayOfWeek2) => {
  DayOfWeek2[DayOfWeek2["Mon"] = 1] = "Mon";
  DayOfWeek2[DayOfWeek2["Tue"] = 2] = "Tue";
  DayOfWeek2[DayOfWeek2["Wed"] = 3] = "Wed";
  DayOfWeek2[DayOfWeek2["Thu"] = 4] = "Thu";
  DayOfWeek2[DayOfWeek2["Fri"] = 5] = "Fri";
  DayOfWeek2[DayOfWeek2["Sat"] = 6] = "Sat";
  DayOfWeek2[DayOfWeek2["Sun"] = 0] = "Sun";
  return DayOfWeek2;
})(DayOfWeek || {});

exports.DayOfWeek = DayOfWeek;
//# sourceMappingURL=models.cjs.map
